import { StarFilled, StarOutlined } from "@ant-design/icons";

const StarComponent = (props: { reportValue: any; starred: string; className?: string; starFilledSize: number; starOutlinedSize: number;  starFilledColor?: string; update:any;}) => {

  return (
    <div
      className={props.className}
      onClick={(e) => {
        e.stopPropagation();
        props.update({ reportValue: props.reportValue, isStarred: props.starred === "Y" ? "N" : "Y" });
      }}
    >
      {props.starred === "Y" ? <StarFilled style={{fontSize: props.starFilledSize, color: props?.starFilledColor}}/> : <StarOutlined style={{fontSize: props?.starOutlinedSize, color: props.starFilledColor}}/>}
    </div>
  );
};

export default StarComponent;
